import type { Page } from '@hello-aria/api-client'
import { toListQuery } from '@hello-aria/makalu-api-client'
import type { QueryStringInput } from '@hello-aria/query-string'
import type { Company } from '@/shared/models/companyModel'
import type {
    CreateMember,
    CreateMemberGateway,
    Member,
    UpdateMember,
    UpdateMemberGateway
} from '@/shared/models/memberModel'
import { trackEvent } from '@/shared/utils/analyticsUtils'
import { makaluApi } from '@/shared/utils/makaluApiClient'
import { removeWhiteSpace } from '@/shared/utils/stringUtils'

export const listMembers = (companyId: Company['id'], query: QueryStringInput): Promise<Page<Member>> =>
    makaluApi.listPage('/companies/{companyId}/member', {
        params: { path: { companyId }, query: toListQuery(query) }
    })

export const getMember = (companyId: Company['id'], memberId: string): Promise<Member> =>
    makaluApi.GET('/companies/{companyId}/member/{memberId}', { params: { path: { companyId, memberId } } })

export const createMember = async (
    companyId: Company['id'],
    { name, email, privileges }: CreateMember
): Promise<Member> => {
    const body: CreateMemberGateway = { email: removeWhiteSpace(email), privileges, name }
    const member = await makaluApi.POST('/companies/{companyId}/member', { params: { path: { companyId } }, body })

    trackEvent('Create_Member')

    return member
}

export const updateMember = async (
    companyId: Company['id'],
    { id, name, email, privileges }: UpdateMember
): Promise<Member> => {
    const body: UpdateMemberGateway = { email: email ? removeWhiteSpace(email) : undefined, name, privileges }
    const member = await makaluApi.PATCH('/companies/{companyId}/member/{memberId}', {
        params: { path: { companyId, memberId: id } },
        body
    })

    trackEvent('Update_Member')

    return member
}

export const deleteMember = async (companyId: Company['id'], memberId: Member['id']): Promise<Member> => {
    const member = await makaluApi.DELETE('/companies/{companyId}/member/{memberId}', {
        params: { path: { companyId, memberId } }
    })

    trackEvent('Delete_Member')

    return member
}
